// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Kartenterminal",
    description: "Mit dem Kartenterminal an der Rezeption direkt aus der Buchung kassieren",
    count: "{count} Terminal | {count} Terminals",
  },
  settings: {
    title: "Kartenterminals an der Rezeption",
    lead: "Kassieren Sie mit dem Kartenterminal direkt aus der Buchung: Der Betrag erscheint am Gerät, der Gast zahlt mit Karte und die Buchung wird automatisch als bezahlt markiert.",
    listTitle: "Ihre Terminals",
    add: "Terminal hinzufügen",
    loading: "Wird geladen…",
    empty: "Sie haben noch kein Kartenterminal verbunden.",
    simulatorTag: "Simulator",
    online: "Online",
    offlineSince: "Offline · zuletzt {when}",
    neverConnected: "Noch nicht verbunden",
    bridgeVersion: "Brücke {version}",
    token: "Token",
    newToken: "Neues Token",
    remove: "Entfernen",
    howTitle: "So wird es verbunden",
    how1: "Fügen Sie das Terminal hier hinzu und kopieren Sie sein Token (es wird nur einmal angezeigt).",
    how2: "Starten Sie auf dem Rezeptionscomputer, an dem das Terminal angeschlossen ist, die WACheckin-Brücke mit diesem Token.",
    how3: "Sobald hier „Online“ steht, können Sie aus jeder Buchung kassieren: Zahlung hinzufügen → Karte / Terminal.",
    bankNote: "Bei Redsys müssen Sie bei Ihrer Bank „TPV-PC“ (Modus Implantado) und ein dafür zertifiziertes Terminal beauftragen. Ein eigenständiges WLAN- oder 4G-Terminal lässt sich nicht verbinden.",
    addTitle: "Terminal hinzufügen",
    nameLabel: "Name",
    namePlaceholder: "Zum Beispiel: Rezeption",
    typeLabel: "Typ",
    typeReal: "Redsys-Terminal (TPV-PC)",
    typeRealHint: "Das Terminal Ihrer Bank, am Rezeptionscomputer angeschlossen.",
    typeSim: "Simulator",
    typeSimHint: "Zum Testen ohne Gerät. Es wird kein Geld bewegt.",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    create: "Hinzufügen",
    saveError: "Speichern nicht möglich. Bitte erneut versuchen.",
    loadError: "Die Terminals konnten nicht geladen werden.",
    tokenTitle: "Token des Terminals",
    tokenLead: "Tragen Sie diese beiden Werte in die Brücke am Rezeptionscomputer ein.",
    apiLabel: "Server",
    tokenLabel: "Token",
    copy: "Kopieren",
    copied: "Kopiert",
    tokenOnce: "Jetzt speichern: Es wird nicht erneut angezeigt. Geht es verloren, erzeugen Sie ein neues; das alte wird ungültig.",
    done: "Fertig",
    newTokenConfirm: "Neues Token für „{name}“ erzeugen? Das aktuelle wird ungültig und muss in der Brücke neu eingetragen werden.",
    removeConfirm: "Terminal „{name}“ entfernen? Es können keine Zahlungen mehr daran gesendet werden.",
    removed: "Terminal entfernt.",
  },
  add: {
    sendTitle: "Am Terminal kassieren",
    sendHint: "Der Betrag erscheint am Gerät und die Buchung wird beim Bezahlen automatisch als bezahlt markiert.",
    online: "online",
    offline: "offline",
    noneOnline: "Kein Terminal ist gerade online. Prüfen Sie, ob der Rezeptionscomputer an und die Brücke geöffnet ist.",
    manualTitle: "Bereits kassiert, nur erfassen",
    manualHint: "Wird als bezahlt erfasst, ohne über das Terminal zu gehen.",
    submit: "Am Terminal kassieren",
  },
  line: {
    pendiente: "Wird ans Terminal gesendet",
    enviado: "Am Terminal",
    sin_respuesta: "Keine Antwort · prüfen",
  },
  cobro: {
    terminal: "Terminal",
    cancel: "Zahlung abbrechen",
    hide: "Im Hintergrund weiterlaufen lassen",
    notCharged: "Nicht kassiert",
    wasCharged: "Ja, kassiert",
    retry: "Erneut versuchen",
    close: "Schließen",
    authCode: "Autorisierung {code}",
    genericError: "Konnte nicht abgeschlossen werden. Bitte erneut versuchen.",
    title: {
      pendiente: "Wird ans Terminal gesendet…",
      enviado: "Bitten Sie um die Karte",
      cobrado: "Kassiert",
      rechazado: "Karte abgelehnt",
      cancelado: "Zahlung abgebrochen",
      error: "Das Terminal meldete einen Fehler",
      caducado: "Das Terminal hat nicht geantwortet",
      sin_respuesta: "Wurde kassiert?",
    },
    text: {
      pendiente: "Der Betrag erscheint in wenigen Sekunden am Terminal.",
      enviado: "Der Betrag ist am Terminal. Sobald bezahlt ist, wird die Buchung automatisch markiert.",
      cobrado: "Diese Zahlung ist in der Buchung erfasst.",
      rechazado: "Es wurde nichts kassiert.",
      cancelado: "Es wurde nichts kassiert.",
      error: "Es wurde nichts kassiert.",
      caducado: "Es wurde nichts kassiert.",
      sin_respuesta: "Das Terminal hat kein Ergebnis zurückgegeben. Prüfen Sie das Gerät oder den Beleg, bevor Sie erneut kassieren.",
    },
  },
  qr: {
    button: "QR anzeigen",
    title: "Zum Bezahlen scannen",
    text: "Der Gast scannt ihn mit dem Handy und zahlt auf der sicheren Seite des Zahlungsanbieters. Die Buchung wird automatisch als bezahlt markiert.",
    copy: "Link kopieren",
    copied: "Link kopiert",
    close: "Schließen",
  },
};
